<template>
  <div class="control-section">
    <div align='center'>
      <ejs-chart ref='chart' style='display:block'  align='center' id='chartcontainer' :title='title' :height='height' :primaryXAxis='primaryXAxis'
                 :primaryYAxis='primaryYAxis' :chartArea='chartArea' :width='width' :tooltip='tooltip' :legendSettings='legend' :zoomSettings='zoomSettings' selectionMode='DragX' :chartMouseClick="chartMouseClick">
        <e-series-collection>
          <e-series :dataSource='seriesData1' type='Column' xName='x' yName='y' :name='$t("TS.callFailedCount")' width=2 :marker='marker' fill='#FF2727'> </e-series>
          <e-series :dataSource='seriesData2' type='Column' xName='x' yName='y' :name='$t("TS.callCount")' width=2 :marker='marker' fill='#3BA1FF' > </e-series>
        </e-series-collection>
      </ejs-chart>
    </div>
    <CustomDialog ref='searchPage' :element='dialog.element.eleSearch' :styles='dialog.stylesSearch' :messages='dialog.messages.search'>
      <template v-slot:dialog-content>
        <QueryDataDialog ref="query"></QueryDataDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='singleCallFailCountPage' :element='dialog.element.eleSingle' :styles='dialog.stylesDetail' :messages='dialog.messages.single'>
      <template v-slot:dialog-content>
        <SingleCallFailCountDialog ref="querySingleCallFailCountDetail"></SingleCallFailCountDialog>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import Vue from 'vue';
import { Browser } from '@syncfusion/ej2-base';
import { ChartPlugin, ColumnSeries, Category, DataLabel, Tooltip, Legend, Zoom, ScrollBar, Selection } from '@syncfusion/ej2-vue-charts';
import CustomDialog from '../../common/CustomDialog';
import QueryDataDialog from '../QueryDataDialog';
import SingleCallFailCountDialog from './SingleCallFailCountDialog';
import Global from '../Global';
import bus from '../bus.js';

Vue.use(ChartPlugin);

export default {
  name: 'CallFailCountChart',
  components: {
    CustomDialog,
    QueryDataDialog,
    SingleCallFailCountDialog
  },
  data() {
    return {
      searchConditions: '',
      singledata: '',
      // olapUrl: `${window.document.location.origin.split('8080')[0]}/18721`,
      olapUrl: Global.olapUrl,
      seriesData1: [],
      seriesData2: [],
      /* seriesData1: [
        { x: '00:00-01:00', y: 37 }, { x: '01:00-02:00', y: 23 }, { x: '02:00-03:00', y: 18 },{ x: '03:00-04:00', y: 16 },{ x: '04:00-05:00', y: 16 },{ x: '05:00-06:00', y: 37 }, { x: '06:00-07:00', y: 23 }, { x: '07:00-08:00', y: 18 },{ x: '08:00-09:00', y: 37 }, { x: '09:00-10:00', y: 23 }, { x: '10:00-11:00', y: 18 },{ x: '11:00-12:00', y: 16 }, { x: '12:00-13:00', y: 47 }, { x: '13:00-14:00', y: 26 },{ x: '14:00-15:00', y: 46 }, { x: '15:00-16:00', y: 27 }, { x: '17:00-18:00', y: 56 },{ x: '18:00-19:00', y: 46 }, { x: '19:00-20:00', y: 27 }, { x: '20:00-21:00', y: 56 },{ x: '21:00-22:00', y: 46 }, { x: '22:00-23:00', y: 27 }
      ],

      seriesData2: [
        { x: '00:00-01:00', y: 37 }, { x: '01:00-02:00', y: 23 }, { x: '02:00-03:00', y: 18 },{ x: '03:00-04:00', y: 16 },{ x: '04:00-05:00', y: 16 },{ x: '05:00-06:00', y: 37 }, { x: '06:00-07:00', y: 23 }, { x: '07:00-08:00', y: 18 },{ x: '08:00-09:00', y: 38 }, { x: '09:00-10:00', y: 17 }, { x: '10:00-11:00', y: 26 },{ x: '11:00-12:00', y: 26 }, { x: '12:00-13:00', y: 77 }, { x: '13:00-14:00', y: 46 },{ x: '14:00-15:00', y: 46 }, { x: '15:00-16:00', y: 27 }, { x: '17:00-18:00', y: 56 },{ x: '18:00-19:00', y: 46 }, { x: '19:00-20:00', y: 27 }, { x: '20:00-21:00', y: 56 },{ x: '21:00-22:00', y: 46 }, { x: '22:00-23:00', y: 27 }
      ], */
      // Initializing Primary X Axis
      primaryXAxis: {
        valueType: 'Category',
        zoomFactor: 0.99,
        zoomPosition: 0,
        interval: 1,
        majorGridLines: { width: 0 },
        edgeLabelPlacement: 'Shift',
        title: this.$t('TS.ts_xAxis_time'),
      },

      // Initializing Primary Y Axis
      primaryYAxis:
        {
          title: this.$t('TS.ts_count'),
          labelFormat: '{value}',
          minimum: 0,
          maximum: 10
          // majorGridLines: { width: 0 }//,
          // majorTickLines: { width: 0 }, lineStyle: { width: 0 }, labelStyle: { color: 'transparent' }
        },
      height: Browser.isDevice ? '100%' : '650px',
      width: Browser.isDevice ? '100%' : '60%',
      marker:
        { dataLabel:
            { visible: false, position: 'Top', font: { fontWeight: '600', color: '#ffffff' }
            }

        },

      tooltip: {
        enable: true
      },

      legend: {
        visible: true,
        position: 'Top'
      },
      zoomSettings: {
        mode: 'X',
        enableMouseWheelZooming: true,
        enablePinchZooming: true,
        // enableSelectionZooming: true,
        enableScrollbar: true,
        toolbarItems: ['ZoomIn', 'ZoomOut']
      },
      chartArea: {
        border: {
          width: 0
        }
      },

      title: this.$t('TS.callFailureCountStatistics'),
      dialog: {
        styles: {
          width: '60%',
          height: '80%',
          visible: false,
          model: true
        },
        stylesSearch: {
          width: '40%',
          height: '70%',
          visible: false,
          model: true
        },
        stylesDetail: {
          width: '95%',
          height: '78%',
          visible: false,
          zIndex: 1100,
          model: true
        },
        element: {
          eleSearch: {
            target: this.$refs.callFailCountChart,
            refName: 'eleSearch',
            buttonGroup: [
              { click: this.closeSearch, buttonModel: { content: this.$t('TS.ts_cancell') } },
              { click: this.queryConfirmFunc, buttonModel: { content: this.$t('TS.ts_ok'), isPrimary: true } }
            ],
            title: this.$t('TS.ts_search'),
            isClose: true
          },
          eleSingle: {
            target: this.$refs.callFailCountChart,
            refName: 'eleSingle',
            buttonGroup: [
              { click: this.closeSinglePage, buttonModel: { content: this.$t('TS.ts_cancell') } }
            ],
            title: this.$t('TS.ts_call_detail'),
            isClose: true
          }
        },
        messages: {
          search: {
            title: this.$t('TS.gs_search')
          },
          single: {
            title: this.$t('TS.ts_call_detail')
          }
        }
      }
    };
  },
  provide: {
    chart: [ColumnSeries, Legend, DataLabel, Category, Tooltip, Zoom, ScrollBar, Selection]
  },
  methods: {
    chartMouseClick(args) {
      const doc = document.getElementById(args.target).getAttribute('aria-label');
      if (doc !== null) {
        const This = this;
        const index = doc.lastIndexOf(':');
        const xAxisLabel = doc.substr(0, index);
        // let url = window.document.location.origin+'/18721/lte/ems/olap/getSingleCallSetUpTimeDetail.html';//todo url，其余逻辑不用改
        const type = parseInt(args.target.split("_")[2]);
        let callCauseList = [];
        callCauseList.push(type);
        if (type == 1) { //全部
          callCauseList.push(0);
        }
        const params = {
          timeInterval: This.searchConditions.timeInterval,
          neId: This.searchConditions.neId,
          startdate: This.searchConditions.startdate,
          enddate: This.searchConditions.enddate,
          xAxisValue: xAxisLabel,
          callCause: callCauseList
        };
        console.log(params);
        if (xAxisLabel === '') {
          return;
        }
        const xAxis = [this.$t('TS.ts_chart_single_call'), this.$t('TS.ts_chart_group_call'), this.$t('TS.ts_chart_single_video'), this.$t('TS.ts_chart_group_video')];
        // 单周期数据获取
        const url = `${This.olapUrl}/lte/ems/olap/voice/getSingleCallCountByTypeDetail.html?startDate=${This.searchConditions.startdate}&endDate=${This.searchConditions.enddate}&interval=${This.searchConditions.timeInterval}&neId=${This.searchConditions.neId}&xAxisValue=${xAxisLabel}`;
        // const url = `/olap/lte/ems/olap/getSingleCallFailCountDetail.html?startDate=${This.searchConditions.startdate}&endDate=${This.searchConditions.enddate}&interval=${This.searchConditions.timeInterval}&neId=${This.searchConditions.neId}&xAxisValue=${xAxisLabel}`;
        This.$axios.get(url).then((response) => {
          if (response && response.status === 200) {
            const resultContent = response.data;
            const allCountArr = [];
            const failCountArr = [];
            let $maximum = 0;
            let value = 0;
            for (let i = 0; i < xAxis.length; i++) {
              const allCountObj = {
                x: xAxis[i],
                y: resultContent.yAxis[i]
              };
              value = resultContent.yAxis[i];
              $maximum = ($maximum < value) ? value : $maximum;
              const failCountObj = {
                x: xAxis[i],
                y: resultContent.yAxis1[i]
              };
              value = resultContent.yAxis1[i];
              $maximum = ($maximum < value) ? value : $maximum;
              allCountArr.push(allCountObj);
              failCountArr.push(failCountObj);

            }
            // This.seriesData1 = allCountArr;
            // This.seriesData2 = failCountArr;
            This.$refs.querySingleCallFailCountDetail.$refs.singleCallFailCountChart.ej2Instances.series[0].dataSource = failCountArr;
            This.$refs.querySingleCallFailCountDetail.$refs.singleCallFailCountChart.ej2Instances.series[1].dataSource = allCountArr;
            This.$refs.querySingleCallFailCountDetail.$refs.singleCallFailCountChart.ej2Instances.primaryYAxis.maximum = ($maximum < 10) ? 10 : null;
            This.$refs.querySingleCallFailCountDetail.$refs.singleCallFailCountChart.ej2Instances.animate();
          }
        });
        bus.$emit('callDetail', params);
        This.$refs.singleCallFailCountPage.show();
      }
    },
    setSinglePage() {
      this.$refs.singleCallFailCountPage.show();
    },
    closeSinglePage() {
      this.$refs.singleCallFailCountPage.clear();
      this.$refs.singleCallFailCountPage.close();
    },
    searchPage() {
      /* if (this.isChooseNe() === false) {
      return;
    } */
      this.$refs.searchPage.show();
      return null;
    },
    closeSearch() {
      this.$refs.searchPage.clear();
      this.$refs.searchPage.close();
    },
    queryConfirmFunc() {
      const This = this;
      // let url = window.document.location.origin+'/18721/lte/ems/olap/getAllCountAndFailCount.html';
      this.searchConditions = This.$refs.query.getSearchCondition();
      console.log(this.searchConditions);
      if (this.searchConditions) {
        const url = `${This.olapUrl}/lte/ems/olap/voice/getAllCountAndFailCount.html?startDate=${this.searchConditions.startdate}&endDate=${this.searchConditions.enddate}&interval=${this.searchConditions.timeInterval}&neId=${this.searchConditions.neId}`;
        // const url = `/olap/lte/ems/olap/voice/getAllCountAndFailCount.html?startDate=${this.searchConditions.startdate}&endDate=${this.searchConditions.enddate}&interval=${this.searchConditions.timeInterval}&neId=${this.searchConditions.neId}`;
        This.$loading.showLoadding(this.$t('MML.loadingTip'));
        This.$axios.get(url).then((response) => {
          if (response && response.status === 200) {
            const resultContent = response.data;
            const failCountArr = [];
            const allCountArr = [];
            let $ymaximum = 0;
            let value = 0;
            for (let i = 0; i < resultContent.xAxis.length; i++) {
              value = resultContent.yAxis[i];
              $ymaximum = ($ymaximum < value) ? value : $ymaximum;
              const failCountObj = {
                x: resultContent.xAxis[i],
                y: resultContent.yAxis[i]
              };
              value = resultContent.yAxis1[i];
              $ymaximum = ($ymaximum < value) ? value : $ymaximum;
              const allCountObj = {
                x: resultContent.xAxis[i],
                y: resultContent.yAxis1[i]
              };
              failCountArr.push(failCountObj);
              allCountArr.push(allCountObj);
            }
            This.seriesData1 = failCountArr;
            This.seriesData2 = allCountArr;
            $ymaximum = ($ymaximum < 10) ? 10 : null;
            const newYAxis = {
              title: this.$t('TS.ts_count'),
              labelFormat: '{value}',
              maximum: $ymaximum
            };
            This.primaryYAxis = newYAxis;
            let zoomFactor = 0.99;
            if (resultContent.xAxis.length > 6) {
              zoomFactor = (6 / resultContent.xAxis.length).toFixed(2);
            }
            const newPrimaryXAxis = {
              valueType: 'Category',
              zoomFactor: zoomFactor,
              zoomPosition: 0,
              interval: 1,
              majorGridLines: { width: 0 },
              edgeLabelPlacement: 'Shift',
              title: this.$t('TS.ts_xAxis_time'),
            };
            This.primaryXAxis = newPrimaryXAxis;
          }
          This.closeSearch();
          // This.$refs.searchPage.close();
          This.$loading.hideLoadding();
        }).catch(err => {
          This.$loading.hideLoadding();
        });
      }
    }
  }
};
</script>

<style scoped>

</style>
